<span class="badge badge-info">
    <span class="icon"><vn-icon name="theme-badge" size="10" /></span> <span class="title">{{ promotionTitle }}</span>
</span>
